import React, { useEffect } from 'react';
import { BrowserRouter, useSearchParams } from 'react-router-dom';

import AppProvider from './hooks';
import { useAuth } from './hooks/auth';
import Roote from './routes/Root';
import { useDynamicViewport } from './hooks/dynamicViewPort';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './css/global.css';
import './css/chat.css';

const AppContent: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { loadConfigAparrence, configAparrence } = useAuth();
  const viewportHeight = useDynamicViewport();

  useEffect(() => {
    const link = String(searchParams.get('emp')).toUpperCase();

    loadConfigAparrence(link);
  }, [searchParams]);

  const divStyleBackGround = {
    background:
      configAparrence?.corPlanoFundoPrincipal === null
        ? `url('${process.env.REACT_APP_API_URL}/BackGroundImage/${configAparrence?.planoFundoPrincipal}') no-repeat center/cover, linear-gradient(108deg, #FFF 0%, #A9C4D8 100%)`
        : configAparrence?.corPlanoFundoPrincipal,
  };

  document.documentElement.style.setProperty(
    '--cor-primaria',
    configAparrence?.corPrincipal ?? '#4397D5'
  );

  document.documentElement.style.setProperty(
    '--cor-caixa-texto-operador',
    configAparrence?.corCaixaTextoOperador ?? '#DD6A00'
  );
  document.documentElement.style.setProperty(
    '--cor-caixa-texto-cliente',
    configAparrence?.corCaixaTextoCliente ?? '#4397D5'
  );
  document.documentElement.style.setProperty(
    '--cor-texto-operador',
    configAparrence?.corTextoOperador ?? '#FFFFFF'
  );
  document.documentElement.style.setProperty(
    '--cor-texto-cliente',
    configAparrence?.corTextoCliente ?? '#FFFFFF'
  );

  document.documentElement.style.setProperty(
    '--cor-titulo',
    configAparrence?.corTitulo ?? '#FFFFFF'
  );
  document.documentElement.style.setProperty(
    '--cor-nome-operador-cliente',
    configAparrence?.corNomeOperadorCliente ?? '#FFFFFF'
  );

  // Aplicar altura dinâmica ao root
  const root = document.getElementById('root');
  if (root) {
    root.style.height = `${viewportHeight}px`;
  }

  return (
    <div className="h-100 w-100 cls-app" style={divStyleBackGround}>
      <Roote />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <div className="h-100 w-100">
      <BrowserRouter>
        <AppProvider>
          <AppContent />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
